module.exports = __webpack_public_path__ + "img/IMG_0073.c0dd9938.jpg";